import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { EditInsiderDataComponent } from "../../modals/edit-insider-data/edit-insider-data.component";
import { MapInsiderDataComponent } from "../../modals/map-insider-data/map-insider-data.component";
import { MappingService } from "src/core/services/mapping.service";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ViewInsiderDataComponent } from "../../modals/view-insider-data/view-insider-data.component";
import { MappingFilter } from "../../../../../api/models/mapping-filter";
import { InsiderMappingService } from "../../../../../api/services/insider-mapping.service";
import { MessageService } from "primeng/api";
import { InsiderType } from "src/api/models";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-insider-unprocessed",
  // imports: [],
  templateUrl: "./unprocessed.component.html",
  styleUrl: "./unprocessed.component.css",
  standalone: false,
})
export class InsiderUnprocessedComponent implements OnInit, OnChanges {
  @Input() isActive: boolean = false;
  private hasLoadedOnce = false;
  reportingEntityTypes = InsiderType.values();
  selectedReportingEntityType: InsiderType | undefined;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"]?.currentValue === true) {
      this.hasLoadedOnce = false;
    }
  }
  ref!: DynamicDialogRef;
  formData = {
    Name: "",
    Cik: "",
  };
  unprocessedInsiders: any[] = [];
  selectedInsiders: any[] = [];
  selectedDialogRow: any = null;

  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  // Pagination for Insiders
  First = 0;
  Rows = 10;
  insiderName?: string;
  issuerName?: string;
  reportingEntityName?: string;
  cikNumber?: string;
  isLoading: boolean = false;

  constructor(
    public mappingService: MappingService,
    public dialogService: DialogService,
    public insiderService: InsiderMappingService,
    public _messageService: MessageService
  ) {}

  ngOnInit(): void {
    // this.mappingService.getInsiders().then((data) => {
    //   this.unprocessedInsiders = data;
    // });
  }
  get isGroupMapEnabled(): boolean {
    if (this.selectedInsiders.length < 2) return false;

    const allIndividual = this.selectedInsiders.every(
      (x) => x.asReportedReportingEntityType === "INDIVIDUAL"
    );

    const noneIndividual = this.selectedInsiders.every(
      (x) => x.asReportedReportingEntityType !== "INDIVIDUAL"
    );

    return allIndividual || noneIndividual;
  }

  get groupMapTooltip(): string {
    if (this.selectedInsiders.length < 2) {
      return "Select at least two rows to enable grouping";
    }

    const allIndividual = this.selectedInsiders.every(
      (x) => x.asReportedReportingEntityType === "INDIVIDUAL"
    );

    const noneIndividual = this.selectedInsiders.every(
      (x) => x.asReportedReportingEntityType !== "INDIVIDUAL"
    );

    if (!(allIndividual || noneIndividual)) {
      return "Only Individual or Only Non-Individual can be grouped";
    }

    return "";
  }

  getUnprocessedInsiders() {
    const params: MappingFilter = {
      searchByName: this.issuerName === "" ? undefined : this.issuerName,
      searchByInsiderName:
        this.insiderName === "" ? undefined : this.insiderName,
      reportingEntityName:
        this.reportingEntityName === "" ? undefined : this.reportingEntityName,

      insiderType: this.selectedReportingEntityType,
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      status: "UNPROCESSED",
    };
    this.isLoading = true;
    this.insiderService.getInsiderMapping(params).subscribe({
      next: (value) => {
        this.unprocessedInsiders = value.UnprocessedInsider ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedInsiders?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  openMapModal(product?: any, event?: Event) {
    if (event) event.preventDefault();
    this.ref = this.dialogService.open(MapInsiderDataComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "60vw" },
      contentStyle: { overflow: "auto" },
      header: "Mapping",
      data: {
        insiders:
          this.selectedInsiders.length > 0 ? this.selectedInsiders : [product],
      },
    });
    this.ref.onClose.subscribe((refresh) => {
      if (refresh) {
        this.getUnprocessedInsiders();
        this.selectedInsiders = [];
      }
    });
  }

  onInsiderPageChange(event: any) {
    this.First = event.first;
    this.Rows = event.rows;
  }
  onGroupMapClick() {
    if (this.selectedInsiders.length > 0) {
      this.openMapModal();
    }
  }

  loadData(event: any) {
    if (!this.isActive) return;
    if (!this.hasLoadedOnce && event.first === 0) {
      this.hasLoadedOnce = true;
    } else if (!this.hasLoadedOnce) {
      return;
    }

    if (event.first > 0 && this.paginator.pageSize !== event.rows) {
      this.paginator.pageNumber = 1;
      this.First = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.First = event.first;
    }

    this.paginator.pageSize = event.rows;
    this.getUnprocessedInsiders();
  }

  pageChange(event: any) {
    this.First = event.first;
    this.Rows = event.rows;
  }

  onSearch() {
    this.First = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedInsiders();
  }
  // isRowSelected(insider: any): boolean {
  //   return this.selectedInsiders.some(
  //     (selected) => selected.asReportedInsiderId === insider.asReportedInsiderId
  //   );
  // }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }

  onPaste(
    event: ClipboardEvent,
    field: "issuerName" | "insiderName" | "reportingEntityName"
  ): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this[field] = newValue;
    });
  }
}
